module.exports = __webpack_public_path__ + "img/technology-20.df607221.png";